// extracted by mini-css-extract-plugin
export default {"root":"xq8X2CeCTxnPPI2BdQ3e","nonlinked":"tEil87u34pK5UkUHCuZT","placeHolderShimmer":"N8tPaAxex1MSOnBv3bf8"};